import React, { useState, useEffect } from "react";
import { navigation, siteConfig, logoUrl } from "../data/mock";
import { Menu, X, PenTool } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <header
        className={`fixed top-10 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? "bg-[rgb(17,17,19)]/95 backdrop-blur-md border-b border-[rgb(63,63,63)]"
            : "bg-transparent"
        }`}
      >
        <div className="max-w-[1200px] mx-auto px-6 md:px-8">
          <div className="flex items-center justify-between h-20">
            {/* Logo - Corporate Brand */}
            <Link
              to="/"
              className="flex items-center gap-2.5 group"
            >
              <img
                src={logoUrl}
                alt="ItzGreen Music"
                className="h-10 w-auto object-contain rounded"
              />
              <span
                className="text-white text-sm tracking-[0.2em] font-semibold hidden sm:inline"
                style={{ fontFamily: "'Oswald', sans-serif" }}
              >
                ITZGREEN <span className="text-[rgb(161,161,170)] font-normal">ADMIN</span>
              </span>
            </Link>

            {/* Desktop Nav - B2B Focused */}
            <nav className="hidden md:flex items-center gap-8">
              {navigation.map((item) =>
                item.isCta ? (
                  <a
                    key={item.label}
                    href={item.href}
                    target={item.isExternal ? "_blank" : undefined}
                    rel={item.isExternal ? "noopener noreferrer" : undefined}
                    className="inline-flex items-center gap-2 text-[rgb(17,17,19)] bg-[rgb(218,255,1)] text-xs tracking-[0.15em] font-semibold px-5 py-2.5 rounded-lg hover:bg-[rgb(166,190,21)] hover:shadow-[0_0_25px_rgba(218,255,1,0.4),0_8px_20px_rgba(218,255,1,0.25)] transition-all duration-300"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    <PenTool size={12} />
                    {item.label}
                  </a>
                ) : item.isRoute ? (
                  <Link
                    key={item.label}
                    to={item.href}
                    className="text-[rgb(161,161,170)] text-xs tracking-[0.2em] font-medium hover:text-[rgb(218,255,1)] transition-colors duration-200"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {item.label}
                  </Link>
                ) : (
                  <a
                    key={item.label}
                    href={item.href}
                    className="text-[rgb(161,161,170)] text-xs tracking-[0.2em] font-medium hover:text-[rgb(218,255,1)] transition-colors duration-200"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {item.label}
                  </a>
                )
              )}
            </nav>

            {/* Mobile Toggle */}
            <button
              className="md:hidden text-white p-2"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Toggle menu"
            >
              {mobileOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.25 }}
            className="fixed inset-0 z-40 bg-[rgb(17,17,19)] pt-24 px-6"
          >
            <nav className="flex flex-col gap-6">
              {navigation.map((item) =>
                item.isCta ? (
                  <a
                    key={item.label}
                    href={item.href}
                    target={item.isExternal ? "_blank" : undefined}
                    rel={item.isExternal ? "noopener noreferrer" : undefined}
                    className="inline-flex items-center justify-center gap-2 text-[rgb(17,17,19)] bg-[rgb(218,255,1)] text-sm tracking-[0.15em] font-semibold px-6 py-4 rounded-lg mt-4"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                    onClick={() => setMobileOpen(false)}
                  >
                    <PenTool size={14} />
                    {item.label}
                  </a>
                ) : item.isRoute ? (
                  <Link
                    key={item.label}
                    to={item.href}
                    className="text-white text-xl tracking-[0.2em] font-semibold hover:text-[rgb(218,255,1)] transition-colors py-2 border-b border-[rgb(63,63,63)]"
                    style={{ fontFamily: "'Oswald', sans-serif" }}
                    onClick={() => setMobileOpen(false)}
                  >
                    {item.label}
                  </Link>
                ) : (
                  <a
                    key={item.label}
                    href={item.href}
                    className="text-white text-xl tracking-[0.2em] font-semibold hover:text-[rgb(218,255,1)] transition-colors py-2 border-b border-[rgb(63,63,63)]"
                    style={{ fontFamily: "'Oswald', sans-serif" }}
                    onClick={() => setMobileOpen(false)}
                  >
                    {item.label}
                  </a>
                )
              )}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;
